import { LOCALES } from '~/i18n/locales';

/**
 * Returns the full BCP 47 locale tag for a given country + language combination.
 *
 * Looks up the language in {@link LOCALES} and checks for a country-specific
 * override (e.g. country `at` + language `de` → `de-AT`).
 * Falls back to the default `language` tag from the LOCALES entry (e.g. `de-DE`).
 */
export function getI18nLocale(country: string, language: string): string {
    const locale = LOCALES.find((l) => l.code === language);
    if (!locale) return language;

    const countryOverrides: Readonly<Record<string, string>> = locale.countryOverrides;
    return (Object.hasOwn(countryOverrides, country) ? countryOverrides[country] : undefined) ?? locale.language;
}
